import React, { useEffect, useState } from 'react'
import { Form, InputContainer, ButtonsContainer, Button, DatosBancoVe, InputContainerCedula, InputContainerCedulaEl, ErrorSpan, } from './DepositElements';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../utils/tools';
import axios from 'axios';
import { API_URL } from '../../const/api';
import CopyIcon from '@mui/icons-material/ContentCopy';
import { infoNotification } from '../../utils/toastNotifications';
import Rbdv from '../../assets/images/RECARGACONBDV.svg';
import pagomovil from '../../assets/images/pagomovil03.png';
import banner from '../../assets/images/BANNERBDV.jpg';
import bdv from '../../assets/images/bancodevenezuela.svg';


const FormBDV = ({ form, handleClose, loading }) => {
  const [t] = useTranslation('global');
  const numero = "04124594594";
  const rif = "J503808586";
 
  const copyContent = async (text, remove) => {
    try {
      let txt = text;
      if (remove) txt = text.substring(1);
      await navigator.clipboard.writeText(txt);
      infoNotification('Contenido copiado al portapapeles', 'top-center');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  return (
    <>
      <Form style={{padding:'1rem', overflow: 'hidden'}}>

          
        <img src={banner} alt='banner' style={{width:'100%'}}/>   
        <DatosBancoVe>
          <p style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            Banco: <span>BANCO DE VENEZUELA</span>
            <img 
              src={bdv} 
              alt="Logo Bdv" 
              style={{ width: 'auto', height: '25px', maxWidth: '100%' }} 
            />
          </p>

          <br></br>
          <p>Nombre: <span>Procesadora de Pagos 365 CA.</span></p>
          <br></br>
          <p>Teléfono: <span>{numero}</span> <CopyIcon onClick={() => copyContent(numero, false)} /></p>
          <br></br>
          <p>Recarga Mínima: <span>10 VES</span></p>
          <p>Recarga Máxima: <span>100.000 VES</span></p>
        </DatosBancoVe>

        <img src={Rbdv} alt='astropay' className={'R4'} style={{width:'50%', marginLeft: '26%', marginTop: '5%', marginBottom:'2%'}}/>
        <img src={pagomovil} alt='pagomovil' className={'R402'} style={{width:'140%', marginTop: '2%', marginLeft: '-17%'}}/>
      
      
        <ButtonsContainer style={{marginTop:'-160px'}}>
          <Button onClick={handleClose}>{t('deposit.btn-cancel')}</Button>
        </ButtonsContainer>
      </Form>
    </>
  )
}

export default FormBDV;